import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import * as lodash from 'lodash';

let canSearch = true;

//Document点击添加按钮逻辑
export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ uploadDocumentShow: true });
  sectionComponent.child.current?.uploadDocument.current?.setState({
    submitting: false,
    DocumentTypeId: null,
  });

  if (pageComponent?.props.pageName !== 'PublicDetail') {
    if (sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource.DocumentTypeId === undefined) {
      httpClient
        .get('Admin/DocumentType/GetSelectOptionList?moduleId=' + sectionComponent.props.moduleId)
        .then(({ data }) => {
          if (data.result) {
            if (data.data.length > 0) {
              let dataSource = data.data;
              let componentDataSource = { ...sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource };
              componentDataSource.DocumentTypeId = dataSource;
              sectionComponent.child.current?.uploadDocument.current?.setState({ componentDataSource });
              sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', dataSource[0]?.Value);
            }
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    } else {
      setTimeout(() => {
        let dataSource = sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource.DocumentTypeId;
        let componentDataSource = { ...sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource };
        componentDataSource.DocumentTypeId = dataSource;
        sectionComponent.child.current?.uploadDocument.current?.setState({ componentDataSource });
        sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', sectionComponent.child.current?.uploadDocument.current?.state.componentDataSource.DocumentTypeId[0]?.Value);
      }, config.setTimeoutMilliSecond);
    }
  }
}

//拖拽文档触发
export function dropDocument({ e, component } = {}) {
  let files = e.dataTransfer.files;
  let fileList = component.state.fileList;
  let date = new Date().getTime();
  const filesArray = Array.from(files);

  setTimeout(() => {
    filesArray.map((file, i) => {
      let have = false;
      fileList.map((oldFile, j) => {
        if (oldFile.name === file.name && oldFile.size === file.size) {
          have = true;
        }
      })
      if (!have) {
        file.uid = 'rc-upload-' + date + '-' + i;
        file.DocumentTypeId = component.formRef.current?.getFieldValue('DocumentTypeId');
        if (file.size / 1024 / 1024 > config.fileUploadLimit) {
          file.status = 'error';
          file.tip = file.name + ' size larger than ' + config.fileUploadLimit + 'M';
        }
        if (file.size === 0) {
          file.status = 'error';
          file.tip = file.name + ' - This file is 0KB and will not be uploaded. Make sure not to select or drag files from a zipped file/folder.';
        }
        fileList.push(file);
      }
    })
    component.setState({ fileList });
    component.setState({ onDragEnterCLass: '' })
  }, config.setTimeoutMilliSecond * 2);
}

//上传逻辑
export function uploadDocumentSubmit({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  console.log('Document上传逻辑');

}

//批量下载
export function batchDownload({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.download({ method: 'post', url: '/Business/Document/BatchDownload', data: { DocumentIdList: sectionComponent.child.current?.state.selectedRowKeys }, filename: pageComponent.state.jobData.JobNum + ' Documents.zip', save: true });
    clearSelectedRowKeys(sectionComponent);
  } else {
    message.warning('You must choose at least one document.');
  }
}

//清除选择的key
function clearSelectedRowKeys(sectionComponent) {
  sectionComponent.child.current?.setState({ selectedRowKeys: [] });
  sectionComponent.child.current?.child.map((folder, i) => {
    folder.current?.setState({ selectedRowKeys: [] });
  })
}

//批量删除
export function batchDelete({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      callback: function () {
        httpClient
          .post('Business/Document/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must choose at least one document.');
  }
}

//Document列表刷新
export function refreshDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.getSectionDataByDefault();

  setTimeout(() => {
    let uie = sectionComponent.state.section.componentList[0].topButtonList[0].buttonList.filter(c => c.actionType === 'Refresh')[0];
    uie.flip = true;
    sectionComponent.setState(sectionComponent.state.section);
  }, 100);

  setTimeout(() => {
    let uie = sectionComponent.state.section.componentList[0].topButtonList[0].buttonList.filter(c => c.actionType === 'Refresh')[0];
    uie.flip = false;
    sectionComponent.setState(sectionComponent.state.section);
  }, 1100);
}

//下载
export function downloadDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.download({ url: '/Business/Document/Download/' + parameter.key, data: null, filename: parameter.Name, save: true });
}

//TrackingPage 下载
export function publicDownloadDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.download({ url: '/Business/Document/PublicDownload/' + parameter.key + '?accessCode=' + pageComponent.props.accessCode, data: null, filename: parameter.Name, save: true });
}

//TrackingPage 批量下载
export function publicBatchDownload({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.download({ method: 'post', url: '/Business/Document/PublicBatchDownload', data: { DocumentIdList: sectionComponent.child.current?.state.selectedRowKeys }, filename: pageComponent.state.jobData.JobNum + ' Documents.zip', save: true });
    clearSelectedRowKeys(sectionComponent);
  } else {
    message.warning('You must choose at least one document.');
  }
}
